// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconLetterA,
    IconBookmark,
    IconReport
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};
// ==============================|| APPLICATION MENU ITEMS ||============================== //
const pointsEnregistrementsEcoles = {
    id: 'enregistrement_des_points112',
    title: ["L. ", <FormattedMessage id="enregistrement_des_points" />],
    type: 'group',
    icon: <IconReport />, // Use a valid icon component here
    children: [

                        {
                            id: 'baseCalculsPoint1',
                            title: ["1. ", <FormattedMessage id="baseCalculsPoint1" />],
                            type: 'item',
                            url: '/formules/BaseCalculPointsSchools'
                        }, 

                        {
                            
                            id: 'avaliations_realise1',
                            title: ["2. ", <FormattedMessage id="avaliations_realise" />],
                            type: 'item',
                            url: '/formules/TypoExamesEAvaliationsSchool'
                        },

                     {
                            id: 'caklendario_lancamento_notas2',
                            title: ["3. ",  <FormattedMessage id="calendario_lancamento_notas" />],
                            type: 'item',
                            url: '/formules/CalendarExameEcoleSchool',
                            breadcrumbs: true

                        }, 
                       
                        {
                            id: 'lista_presence_digital3',
                            title: ["4. ", <FormattedMessage id="lista_presence_digital" />],
                            type: 'item',
                            url:  '/notas/ListaPreseneDigital',
                            breadcrumbs: true
                        },

                        /* {
                            id: 'lancamento_notas_estudante4',
                            title: ["3. ", <FormattedMessage id="lancamento_notas_estudante" />],
                            type: 'item',
                            url:  '/notas/ReleveCoteImpressionAdministracao',
                            breadcrumbs: true
                        }, */
                        
                             {
                                id: 'first_term_second_mark_entry1',
                                title: ["5. ", <FormattedMessage id="first_term_second_mark_entry" />],
                                type: 'item',
                                url:'/notasEcoles/lancerPointsPremierSemestre',
                                breadcrumbs: false
                            },

                            {
                                id: 'lancerPointsEcoleDeuxiemeSemestreRDC6',
                                title: ["6. ", <FormattedMessage id="lancerPointsEcoleDeuxiemeSemestreRDC" />],
                                type: 'item',
                                url:'/notasEcoles/lancerPointsSecondSemestre',
                                breadcrumbs: false
                            }, 
                            
                           /*   {
                                id: 'lancerPointsEcoleDeuxiemeSemestreRDC6',
                                title: ["6. ", <FormattedMessage id="lancerPointsEcoleDeuxiemeSemestreRDC" />],
                                type: 'item',
                                url:'/notasEcoles/lancerPointsSecondSemestre',
                                breadcrumbs: false
                            }, 
                 */
                        {
                            id: 'controle_enregistrement_point7',
                            title: ["6. ", <FormattedMessage id="controle_enregistrement_point1" />],
                            type: 'item',
                            url: '/notas/ControleEnrefistremenrtPoints'
                        },
                  
        ]
        
};

export default pointsEnregistrementsEcoles;
